import { ApiRequest } from '../baseService'

const BaseRoute = 'app/maintenance'

export interface MaintenanceSettingPayload {
  /** Tenant to write to, or null/undefined to write the GLOBAL (all tenants) switch. */
  tenantId?: string | null
  enabled: boolean
  title?: string
  message?: string
  allowTenantAdmin?: boolean
}

/** The global switch plus every tenant's own maintenance configuration. */
function GetOverview() {
  return ApiRequest.get(BaseRoute)
}

/** Turns maintenance on or off for ONE scope — a tenant, or globally when tenantId is omitted. */
function Save(payload: MaintenanceSettingPayload) {
  return ApiRequest.put(BaseRoute, payload)
}

export default {
  GetOverview,
  Save,
}
